import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCooperantOrders({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_ORDERS_REQUEST')

        return axios
            .get(`/orders/cooperant-orders${paginate}${query}`)
            .then(response => {
                commit('GET_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCooperantOrder(context, orderId) {
        return axios
            .get(`/orders/cooperant-orders/${orderId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o zamówieniu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCooperantDelivery(context, {id, payload}) {
        return axios
            .patch(`/deliveries/cooperant-delivery/${id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja dostawy nie powiodła się.')

                return Promise.reject(error)
            })
    },
    printCooperantLabels({ commit }, { printingDeliveriesIds, carrierId }) {
        return axios
            .post('/shipments/cooperant-print', {
                cooperationShipmentDeliveryPrint: printingDeliveriesIds.map(deliveryId => ({
                    deliveryId
                })),
                carrierId
            }, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wygenerowano etykiety przewozowe.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('SHOW_NOTIFICATION', {
                    type: 'error',
                    message: 'Wygenerowanie etykiet przewozowych nie powiodło się.'
                }, { root: true })
                handleApiError(error, 'Wygenerowanie etykiet przewozowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    provideCooperationShipmentDeliveryNumber({ commit }, { deliveryId, deliveryNumber }) {
        return axios
            .post('/shipments/cooperant-print', {
                cooperationShipmentDeliveryPrint : [{
                    deliveryId: parseInt(deliveryId),
                    deliveryNumber: deliveryNumber
                }]
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Numer listu przewozowego został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie numeru listu przewozowego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCooperantDeliveryStatusNames({ commit }) {
        return axios
            .get('/deliveries/dicts/cooperant-delivery-statuses')
            .then(response => {
                commit('GET_COOPERANT_DELIVERY_STATUS_NAMES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów dostaw nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addCooperantComment({ commit }, payload) {
        return axios
            .post('/orders/cooperant-order-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateCooperantOrdersListReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/orders/cooperant-orders?report=true${query}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Po wygenerowaniu raport zostanie wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setCooperantOrdersFilters({ commit }, filters) {
        commit('SET_ORDERS_FILTERS', filters)
    },
    updateCooperantCommentsList({ commit }, commentData) {
        commit('UPDATE_COMMENT_LIST', commentData)
    },
    clearCooperantCommentsList({ commit }) {
        commit('CLEAR_COMMENT_LIST')
    },
    clearCooperantOrdersFilters({ commit }) {
        commit('CLEAR_ORDERS_FILTERS')
    }
}
